import { EnsemblesItem } from './ensemble-item';

export async function fetchCollectionData( collectionSlug: string | null ): Promise<EnsemblesCollectionResponse | null> {
	if ( !collectionSlug ) {
		return null;
	}

	try {
		// https://ensembles.org/ensembles/foundation-gordon-matta-clark-art-collection/items.json
		const response = await fetch( `https://ensembles.org/ensembles/${encodeURIComponent( collectionSlug )}/items.json` );
		if ( !response.ok ) {
			console.warn( 'Could not fetch collection data', response );

			return null;
		}

		const data = await response.json() as EnsemblesCollectionItemsResponse;

		return {
			items: data.items,
			items_count: data.total_count,
		};
	} catch ( e ) {
		console.warn( 'Could not fetch collection data', e );

		return null;
	}
}

export interface EnsemblesCollectionItemsResponse {
	items: EnsemblesItem[]
	total_count: number
}

export interface EnsemblesCollectionResponse {
	items: EnsemblesItem[]
	items_count: number
}
